//# sourceMappingURL=language.mjs.map
/// <reference types="./language.d.mts" />
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../../gleam.mjs";

export class English extends $CustomType {}
export const Language$English = () => new English();
export const Language$isEnglish = (value) => value instanceof English;

export class French extends $CustomType {}
export const Language$French = () => new French();
export const Language$isFrench = (value) => value instanceof French;

export class German extends $CustomType {}
export const Language$German = () => new German();
export const Language$isGerman = (value) => value instanceof German;

export class Spanish extends $CustomType {}
export const Language$Spanish = () => new Spanish();
export const Language$isSpanish = (value) => value instanceof Spanish;

export class Dutch extends $CustomType {}
export const Language$Dutch = () => new Dutch();
export const Language$isDutch = (value) => value instanceof Dutch;

export class Portuguese extends $CustomType {}
export const Language$Portuguese = () => new Portuguese();
export const Language$isPortuguese = (value) => value instanceof Portuguese;

export class Italian extends $CustomType {}
export const Language$Italian = () => new Italian();
export const Language$isItalian = (value) => value instanceof Italian;

export class Finnish extends $CustomType {}
export const Language$Finnish = () => new Finnish();
export const Language$isFinnish = (value) => value instanceof Finnish;

export class Swedish extends $CustomType {}
export const Language$Swedish = () => new Swedish();
export const Language$isSwedish = (value) => value instanceof Swedish;

export class Nynorsk extends $CustomType {}
export const Language$Nynorsk = () => new Nynorsk();
export const Language$isNynorsk = (value) => value instanceof Nynorsk;

export class Bokmal extends $CustomType {}
export const Language$Bokmal = () => new Bokmal();
export const Language$isBokmal = (value) => value instanceof Bokmal;

export class Danish extends $CustomType {}
export const Language$Danish = () => new Danish();
export const Language$isDanish = (value) => value instanceof Danish;

export class Estonian extends $CustomType {}
export const Language$Estonian = () => new Estonian();
export const Language$isEstonian = (value) => value instanceof Estonian;

export class Latvian extends $CustomType {}
export const Language$Latvian = () => new Latvian();
export const Language$isLatvian = (value) => value instanceof Latvian;

export class Lithuanian extends $CustomType {}
export const Language$Lithuanian = () => new Lithuanian();
export const Language$isLithuanian = (value) => value instanceof Lithuanian;

export class Icelandic extends $CustomType {}
export const Language$Icelandic = () => new Icelandic();
export const Language$isIcelandic = (value) => value instanceof Icelandic;

export class Japanese extends $CustomType {}
export const Language$Japanese = () => new Japanese();
export const Language$isJapanese = (value) => value instanceof Japanese;

export class Chinese extends $CustomType {}
export const Language$Chinese = () => new Chinese();
export const Language$isChinese = (value) => value instanceof Chinese;

export class Polish extends $CustomType {}
export const Language$Polish = () => new Polish();
export const Language$isPolish = (value) => value instanceof Polish;

export class Romanian extends $CustomType {}
export const Language$Romanian = () => new Romanian();
export const Language$isRomanian = (value) => value instanceof Romanian;

export class Bulgarian extends $CustomType {}
export const Language$Bulgarian = () => new Bulgarian();
export const Language$isBulgarian = (value) => value instanceof Bulgarian;

export class Croatian extends $CustomType {}
export const Language$Croatian = () => new Croatian();
export const Language$isCroatian = (value) => value instanceof Croatian;

export class Czech extends $CustomType {}
export const Language$Czech = () => new Czech();
export const Language$isCzech = (value) => value instanceof Czech;

export class Greek extends $CustomType {}
export const Language$Greek = () => new Greek();
export const Language$isGreek = (value) => value instanceof Greek;

export class Hungarian extends $CustomType {}
export const Language$Hungarian = () => new Hungarian();
export const Language$isHungarian = (value) => value instanceof Hungarian;

export class Irish extends $CustomType {}
export const Language$Irish = () => new Irish();
export const Language$isIrish = (value) => value instanceof Irish;

export class Slovak extends $CustomType {}
export const Language$Slovak = () => new Slovak();
export const Language$isSlovak = (value) => value instanceof Slovak;

export class Slovene extends $CustomType {}
export const Language$Slovene = () => new Slovene();
export const Language$isSlovene = (value) => value instanceof Slovene;

export class Arabic extends $CustomType {}
export const Language$Arabic = () => new Arabic();
export const Language$isArabic = (value) => value instanceof Arabic;

export class Korean extends $CustomType {}
export const Language$Korean = () => new Korean();
export const Language$isKorean = (value) => value instanceof Korean;

export class Russian extends $CustomType {}
export const Language$Russian = () => new Russian();
export const Language$isRussian = (value) => value instanceof Russian;

export class Turkish extends $CustomType {}
export const Language$Turkish = () => new Turkish();
export const Language$isTurkish = (value) => value instanceof Turkish;

export class Hindi extends $CustomType {}
export const Language$Hindi = () => new Hindi();
export const Language$isHindi = (value) => value instanceof Hindi;

export class Hebrew extends $CustomType {}
export const Language$Hebrew = () => new Hebrew();
export const Language$isHebrew = (value) => value instanceof Hebrew;

export class Vietnamese extends $CustomType {}
export const Language$Vietnamese = () => new Vietnamese();
export const Language$isVietnamese = (value) => value instanceof Vietnamese;

export class Indonesian extends $CustomType {}
export const Language$Indonesian = () => new Indonesian();
export const Language$isIndonesian = (value) => value instanceof Indonesian;

export class Thai extends $CustomType {}
export const Language$Thai = () => new Thai();
export const Language$isThai = (value) => value instanceof Thai;

export class Ukrainian extends $CustomType {}
export const Language$Ukrainian = () => new Ukrainian();
export const Language$isUkrainian = (value) => value instanceof Ukrainian;

export class Malay extends $CustomType {}
export const Language$Malay = () => new Malay();
export const Language$isMalay = (value) => value instanceof Malay;

/**
 * Languages offered in the UI. `Nynorsk` is deliberately absent: automatic
 * detection cannot reliably tell it apart from `Bokmal`, so it can no longer
 * be selected. The variant itself is kept so existing proposals and stored
 * translations still decode and display correctly.
 */
export const all = /* @__PURE__ */ toList([
  /* @__PURE__ */ new English(),
  /* @__PURE__ */ new French(),
  /* @__PURE__ */ new Spanish(),
  /* @__PURE__ */ new German(),
  /* @__PURE__ */ new Dutch(),
  /* @__PURE__ */ new Portuguese(),
  /* @__PURE__ */ new Italian(),
  /* @__PURE__ */ new Finnish(),
  /* @__PURE__ */ new Swedish(),
  /* @__PURE__ */ new Bokmal(),
  /* @__PURE__ */ new Danish(),
  /* @__PURE__ */ new Estonian(),
  /* @__PURE__ */ new Latvian(),
  /* @__PURE__ */ new Lithuanian(),
  /* @__PURE__ */ new Icelandic(),
  /* @__PURE__ */ new Japanese(),
  /* @__PURE__ */ new Chinese(),
  /* @__PURE__ */ new Polish(),
  /* @__PURE__ */ new Romanian(),
  /* @__PURE__ */ new Bulgarian(),
  /* @__PURE__ */ new Croatian(),
  /* @__PURE__ */ new Czech(),
  /* @__PURE__ */ new Greek(),
  /* @__PURE__ */ new Hungarian(),
  /* @__PURE__ */ new Irish(),
  /* @__PURE__ */ new Slovak(),
  /* @__PURE__ */ new Slovene(),
  /* @__PURE__ */ new Arabic(),
  /* @__PURE__ */ new Korean(),
  /* @__PURE__ */ new Russian(),
  /* @__PURE__ */ new Turkish(),
  /* @__PURE__ */ new Hindi(),
  /* @__PURE__ */ new Hebrew(),
  /* @__PURE__ */ new Vietnamese(),
  /* @__PURE__ */ new Indonesian(),
  /* @__PURE__ */ new Thai(),
  /* @__PURE__ */ new Ukrainian(),
  /* @__PURE__ */ new Malay(),
]);

export const default$ = /* @__PURE__ */ new English();

export function to_string(language) {
  if (language instanceof English) {
    return "english";
  } else if (language instanceof French) {
    return "french";
  } else if (language instanceof German) {
    return "german";
  } else if (language instanceof Spanish) {
    return "spanish";
  } else if (language instanceof Dutch) {
    return "dutch";
  } else if (language instanceof Portuguese) {
    return "portuguese";
  } else if (language instanceof Italian) {
    return "italian";
  } else if (language instanceof Finnish) {
    return "finnish";
  } else if (language instanceof Swedish) {
    return "swedish";
  } else if (language instanceof Nynorsk) {
    return "nynorsk";
  } else if (language instanceof Bokmal) {
    return "bokmal";
  } else if (language instanceof Danish) {
    return "danish";
  } else if (language instanceof Estonian) {
    return "estonian";
  } else if (language instanceof Latvian) {
    return "latvian";
  } else if (language instanceof Lithuanian) {
    return "lithuanian";
  } else if (language instanceof Icelandic) {
    return "icelandic";
  } else if (language instanceof Japanese) {
    return "japanese";
  } else if (language instanceof Chinese) {
    return "chinese";
  } else if (language instanceof Polish) {
    return "polish";
  } else if (language instanceof Romanian) {
    return "romanian";
  } else if (language instanceof Bulgarian) {
    return "bulgarian";
  } else if (language instanceof Croatian) {
    return "croatian";
  } else if (language instanceof Czech) {
    return "czech";
  } else if (language instanceof Greek) {
    return "greek";
  } else if (language instanceof Hungarian) {
    return "hungarian";
  } else if (language instanceof Irish) {
    return "irish";
  } else if (language instanceof Slovak) {
    return "slovak";
  } else if (language instanceof Slovene) {
    return "slovene";
  } else if (language instanceof Arabic) {
    return "arabic";
  } else if (language instanceof Korean) {
    return "korean";
  } else if (language instanceof Russian) {
    return "russian";
  } else if (language instanceof Turkish) {
    return "turkish";
  } else if (language instanceof Hindi) {
    return "hindi";
  } else if (language instanceof Hebrew) {
    return "hebrew";
  } else if (language instanceof Vietnamese) {
    return "vietnamese";
  } else if (language instanceof Indonesian) {
    return "indonesian";
  } else if (language instanceof Thai) {
    return "thai";
  } else if (language instanceof Ukrainian) {
    return "ukrainian";
  } else {
    return "malay";
  }
}

export function from_string(language) {
  let $ = $string.lowercase(language);
  if ($ === "english") {
    return new Ok(new English());
  } else if ($ === "french") {
    return new Ok(new French());
  } else if ($ === "german") {
    return new Ok(new German());
  } else if ($ === "spanish") {
    return new Ok(new Spanish());
  } else if ($ === "dutch") {
    return new Ok(new Dutch());
  } else if ($ === "portuguese") {
    return new Ok(new Portuguese());
  } else if ($ === "italian") {
    return new Ok(new Italian());
  } else if ($ === "finnish") {
    return new Ok(new Finnish());
  } else if ($ === "swedish") {
    return new Ok(new Swedish());
  } else if ($ === "nynorsk") {
    return new Ok(new Nynorsk());
  } else if ($ === "bokmal") {
    return new Ok(new Bokmal());
  } else if ($ === "danish") {
    return new Ok(new Danish());
  } else if ($ === "estonian") {
    return new Ok(new Estonian());
  } else if ($ === "latvian") {
    return new Ok(new Latvian());
  } else if ($ === "lithuanian") {
    return new Ok(new Lithuanian());
  } else if ($ === "icelandic") {
    return new Ok(new Icelandic());
  } else if ($ === "chinese") {
    return new Ok(new Chinese());
  } else if ($ === "japanese") {
    return new Ok(new Japanese());
  } else if ($ === "polish") {
    return new Ok(new Polish());
  } else if ($ === "romanian") {
    return new Ok(new Romanian());
  } else if ($ === "bulgarian") {
    return new Ok(new Bulgarian());
  } else if ($ === "croatian") {
    return new Ok(new Croatian());
  } else if ($ === "czech") {
    return new Ok(new Czech());
  } else if ($ === "greek") {
    return new Ok(new Greek());
  } else if ($ === "hungarian") {
    return new Ok(new Hungarian());
  } else if ($ === "irish") {
    return new Ok(new Irish());
  } else if ($ === "slovak") {
    return new Ok(new Slovak());
  } else if ($ === "slovene") {
    return new Ok(new Slovene());
  } else if ($ === "arabic") {
    return new Ok(new Arabic());
  } else if ($ === "korean") {
    return new Ok(new Korean());
  } else if ($ === "russian") {
    return new Ok(new Russian());
  } else if ($ === "turkish") {
    return new Ok(new Turkish());
  } else if ($ === "hindi") {
    return new Ok(new Hindi());
  } else if ($ === "hebrew") {
    return new Ok(new Hebrew());
  } else if ($ === "vietnamese") {
    return new Ok(new Vietnamese());
  } else if ($ === "indonesian") {
    return new Ok(new Indonesian());
  } else if ($ === "thai") {
    return new Ok(new Thai());
  } else if ($ === "ukrainian") {
    return new Ok(new Ukrainian());
  } else if ($ === "malay") {
    return new Ok(new Malay());
  } else {
    return new Error(undefined);
  }
}

export function to_emoji(language) {
  if (language instanceof English) {
    return "🇬🇧";
  } else if (language instanceof French) {
    return "🇫🇷";
  } else if (language instanceof German) {
    return "🇩🇪";
  } else if (language instanceof Spanish) {
    return "🇪🇸";
  } else if (language instanceof Dutch) {
    return "🇳🇱";
  } else if (language instanceof Portuguese) {
    return "🇵🇹";
  } else if (language instanceof Italian) {
    return "🇮🇹";
  } else if (language instanceof Finnish) {
    return "🇫🇮";
  } else if (language instanceof Swedish) {
    return "🇸🇪";
  } else if (language instanceof Nynorsk) {
    return "🇳🇴";
  } else if (language instanceof Bokmal) {
    return "🇳🇴";
  } else if (language instanceof Danish) {
    return "🇩🇰";
  } else if (language instanceof Estonian) {
    return "🇪🇪";
  } else if (language instanceof Latvian) {
    return "🇱🇻";
  } else if (language instanceof Lithuanian) {
    return "🇱🇹";
  } else if (language instanceof Icelandic) {
    return "🇮🇸";
  } else if (language instanceof Japanese) {
    return "🇯🇵";
  } else if (language instanceof Chinese) {
    return "🇨🇳";
  } else if (language instanceof Polish) {
    return "🇵🇱";
  } else if (language instanceof Romanian) {
    return "🇷🇴";
  } else if (language instanceof Bulgarian) {
    return "🇧🇬";
  } else if (language instanceof Croatian) {
    return "🇭🇷";
  } else if (language instanceof Czech) {
    return "🇨🇿";
  } else if (language instanceof Greek) {
    return "🇬🇷";
  } else if (language instanceof Hungarian) {
    return "🇭🇺";
  } else if (language instanceof Irish) {
    return "🇮🇪";
  } else if (language instanceof Slovak) {
    return "🇸🇰";
  } else if (language instanceof Slovene) {
    return "🇸🇮";
  } else if (language instanceof Arabic) {
    return "🇸🇦";
  } else if (language instanceof Korean) {
    return "🇰🇷";
  } else if (language instanceof Russian) {
    return "🇷🇺";
  } else if (language instanceof Turkish) {
    return "🇹🇷";
  } else if (language instanceof Hindi) {
    return "🇮🇳";
  } else if (language instanceof Hebrew) {
    return "🇮🇱";
  } else if (language instanceof Vietnamese) {
    return "🇻🇳";
  } else if (language instanceof Indonesian) {
    return "🇮🇩";
  } else if (language instanceof Thai) {
    return "🇹🇭";
  } else if (language instanceof Ukrainian) {
    return "🇺🇦";
  } else {
    return "🇲🇾";
  }
}

export function to_yes(language) {
  if (language instanceof English) {
    return "Yes";
  } else if (language instanceof French) {
    return "Oui";
  } else if (language instanceof German) {
    return "Ja";
  } else if (language instanceof Spanish) {
    return "Sí";
  } else if (language instanceof Dutch) {
    return "Ja";
  } else if (language instanceof Portuguese) {
    return "Sim";
  } else if (language instanceof Italian) {
    return "Sì";
  } else if (language instanceof Finnish) {
    return "Kyllä";
  } else if (language instanceof Swedish) {
    return "Ja";
  } else if (language instanceof Nynorsk) {
    return "Ja";
  } else if (language instanceof Bokmal) {
    return "Ja";
  } else if (language instanceof Danish) {
    return "Ja";
  } else if (language instanceof Estonian) {
    return "Jah";
  } else if (language instanceof Latvian) {
    return "Jā";
  } else if (language instanceof Lithuanian) {
    return "Taip";
  } else if (language instanceof Icelandic) {
    return "Já";
  } else if (language instanceof Japanese) {
    return "はい";
  } else if (language instanceof Chinese) {
    return "是";
  } else if (language instanceof Polish) {
    return "Tak";
  } else if (language instanceof Romanian) {
    return "Da";
  } else if (language instanceof Bulgarian) {
    return "Да";
  } else if (language instanceof Croatian) {
    return "Da";
  } else if (language instanceof Czech) {
    return "Ano";
  } else if (language instanceof Greek) {
    return "Ναι";
  } else if (language instanceof Hungarian) {
    return "Igen";
  } else if (language instanceof Irish) {
    return "Tá";
  } else if (language instanceof Slovak) {
    return "Áno";
  } else if (language instanceof Slovene) {
    return "Da";
  } else if (language instanceof Arabic) {
    return "نعم";
  } else if (language instanceof Korean) {
    return "예";
  } else if (language instanceof Russian) {
    return "Да";
  } else if (language instanceof Turkish) {
    return "Evet";
  } else if (language instanceof Hindi) {
    return "हाँ";
  } else if (language instanceof Hebrew) {
    return "כן";
  } else if (language instanceof Vietnamese) {
    return "Có";
  } else if (language instanceof Indonesian) {
    return "Ya";
  } else if (language instanceof Thai) {
    return "ใช่";
  } else if (language instanceof Ukrainian) {
    return "Так";
  } else {
    return "Ya";
  }
}

export function to_no(language) {
  if (language instanceof English) {
    return "No";
  } else if (language instanceof French) {
    return "Non";
  } else if (language instanceof German) {
    return "Nein";
  } else if (language instanceof Spanish) {
    return "No";
  } else if (language instanceof Dutch) {
    return "Nee";
  } else if (language instanceof Portuguese) {
    return "Não";
  } else if (language instanceof Italian) {
    return "No";
  } else if (language instanceof Finnish) {
    return "Ei";
  } else if (language instanceof Swedish) {
    return "Nej";
  } else if (language instanceof Nynorsk) {
    return "Nei";
  } else if (language instanceof Bokmal) {
    return "Nei";
  } else if (language instanceof Danish) {
    return "Nej";
  } else if (language instanceof Estonian) {
    return "Ei";
  } else if (language instanceof Latvian) {
    return "Nē";
  } else if (language instanceof Lithuanian) {
    return "Ne";
  } else if (language instanceof Icelandic) {
    return "Nei";
  } else if (language instanceof Japanese) {
    return "いいえ";
  } else if (language instanceof Chinese) {
    return "否";
  } else if (language instanceof Polish) {
    return "Nie";
  } else if (language instanceof Romanian) {
    return "Nu";
  } else if (language instanceof Bulgarian) {
    return "Не";
  } else if (language instanceof Croatian) {
    return "Ne";
  } else if (language instanceof Czech) {
    return "Ne";
  } else if (language instanceof Greek) {
    return "Όχι";
  } else if (language instanceof Hungarian) {
    return "Nem";
  } else if (language instanceof Irish) {
    return "Níl";
  } else if (language instanceof Slovak) {
    return "Nie";
  } else if (language instanceof Slovene) {
    return "Ne";
  } else if (language instanceof Arabic) {
    return "لا";
  } else if (language instanceof Korean) {
    return "아니요";
  } else if (language instanceof Russian) {
    return "Нет";
  } else if (language instanceof Turkish) {
    return "Hayır";
  } else if (language instanceof Hindi) {
    return "नहीं";
  } else if (language instanceof Hebrew) {
    return "לא";
  } else if (language instanceof Vietnamese) {
    return "Không";
  } else if (language instanceof Indonesian) {
    return "Tidak";
  } else if (language instanceof Thai) {
    return "ไม่";
  } else if (language instanceof Ukrainian) {
    return "Ні";
  } else {
    return "Tidak";
  }
}

export function to_na(language) {
  if (language instanceof English) {
    return "N/A";
  } else if (language instanceof French) {
    return "N/A";
  } else if (language instanceof German) {
    return "N/V";
  } else if (language instanceof Spanish) {
    return "N/A";
  } else if (language instanceof Dutch) {
    return "N/B";
  } else if (language instanceof Portuguese) {
    return "N/D";
  } else if (language instanceof Italian) {
    return "N/D";
  } else if (language instanceof Finnish) {
    return "E/T";
  } else if (language instanceof Swedish) {
    return "E/T";
  } else if (language instanceof Nynorsk) {
    return "I/T";
  } else if (language instanceof Bokmal) {
    return "I/T";
  } else if (language instanceof Danish) {
    return "I/T";
  } else if (language instanceof Estonian) {
    return "P/V";
  } else if (language instanceof Latvian) {
    return "N/P";
  } else if (language instanceof Lithuanian) {
    return "N/A";
  } else if (language instanceof Icelandic) {
    return "N/A";
  } else if (language instanceof Japanese) {
    return "該当なし";
  } else if (language instanceof Chinese) {
    return "不适用";
  } else if (language instanceof Polish) {
    return "Nie dotyczy";
  } else if (language instanceof Romanian) {
    return "N/A";
  } else if (language instanceof Bulgarian) {
    return "Н/П";
  } else if (language instanceof Croatian) {
    return "N/P";
  } else if (language instanceof Czech) {
    return "N/A";
  } else if (language instanceof Greek) {
    return "Δ/Ι";
  } else if (language instanceof Hungarian) {
    return "N/A";
  } else if (language instanceof Irish) {
    return "N/B";
  } else if (language instanceof Slovak) {
    return "N/A";
  } else if (language instanceof Slovene) {
    return "N/A";
  } else if (language instanceof Arabic) {
    return "غير منطبق";
  } else if (language instanceof Korean) {
    return "해당 없음";
  } else if (language instanceof Russian) {
    return "Н/Д";
  } else if (language instanceof Turkish) {
    return "Uygulanamaz";
  } else if (language instanceof Hindi) {
    return "लागू नहीं";
  } else if (language instanceof Hebrew) {
    return "לא רלוונטי";
  } else if (language instanceof Vietnamese) {
    return "Không áp dụng";
  } else if (language instanceof Indonesian) {
    return "Tidak berlaku";
  } else if (language instanceof Thai) {
    return "ไม่เกี่ยวข้อง";
  } else if (language instanceof Ukrainian) {
    return "Н/Д";
  } else {
    return "Tidak berkenaan";
  }
}
